<template>
  <b-container fluid>
    <b-row
      v-for="(field, index) in fields"
      :key="index"
    >
      <b-col>
        <b-form-group
          label-cols="12"
          label-cols-sm="12"
          label-cols-md="5"
          label-cols-lg="4"
          label-cols-xl="3"
          label-align-sm="right"
          :label-for="field.key"
        >
          <template v-slot:label>
            {{ field.label }} <span
              v-if="field.required"
              class="text-danger"
            >*</span>
          </template>
          <b-form-input
            v-if="field.fieldType === 'text'"
            :id="field.key"
            v-model="field.value"
          />
          <b-form-input
            v-else-if="field.fieldType === 'password'"
            :id="field.key"
            v-model="field.value"
            type="password"
          />
          <b-form-input
            v-else-if="field.fieldType === 'number'"
            :id="field.key"
            v-model="field.value"
            type="number"
          />
          <b-form-checkbox
            v-else-if="field.fieldType === 'checkbox'"
            :id="field.key"
            v-model="field.value"
            style="padding-top: 0.5rem;"
            class="text-left "
            :value="1"
            :unchecked-value="0"
          />
          <b-form-select
            v-else-if="field.fieldType === 'selected'"
            :id="field.key"
            v-model="field.value"
            :text-field="field.textField"
            :value-field="field.valueField"
            :options="field.resources"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: "InputModal",
    props: {
      fields: {
        required: true
      },
    }

  }
</script>

<style scoped>

</style>
